<template>
    <div class="form-container" style="position:relative">
        <div class="form-header">
            <b-button class="form-backbutton" v-if="step._back_button_visible" :disabled="block_form" @click="goBack"><b-icon icon="arrow-left"></b-icon></b-button>
            <h2 class="step-title" v-if="step._title" v-html="step._title"></h2>
        </div>

        <p class="step-content" v-if="step._content" v-html="step._content"></p>

        <!--Voir pour mettre en modale-->
        <!--<div class="box" v-if="!_.isEmpty(errors)">-->
        <!--    <div>Global Errors</div>-->
        <!--    <div>-->
        <!--            <b-tag>error there error</b-tag>-->
        <!--    </div>-->
        <!--        <div v-for="(error, key) in errors" :key="key">-->
        <!--            <b-tag>{{ error[0] }}</b-tag>-->
        <!--        </div>-->
        <!--</div>-->

        <ValidationObserver :ref="stepName" v-slot="observer">
            <BasicFormStep v-if="isBasicStep"></BasicFormStep>
            <ButtonFormStep v-if="isButtonStep"></ButtonFormStep>
            <KeyboardFormStep v-if="isKeyboardStep"></KeyboardFormStep>
        </ValidationObserver>

        <b-loading :is-full-page="false" v-model="loading"></b-loading>
    </div>
</template>

<script>
import mixin from "./travel_step_mixin";
import BasicFormStep from "./BasicFormStep";
import ButtonFormStep from "./ButtonFormStep";
import KeyboardFormStep from "./KeyboardFormStep";
import form_step_mixin from "./form_step_mixin";

export default {
    mixins: [mixin,form_step_mixin],
    components: {
        KeyboardFormStep,
        BasicFormStep,
        ButtonFormStep
    },
}
</script>
